import { DOMEvents } from "../../../constants/domEvents"

export const sendDragEventsToParent = (container: HTMLElement) => {
  let baseMouseX: number, baseMouseY: number
  const meetingClient = window.MeetOnline.client()

  function handleDragEnd() {
    meetingClient.parentPageCommunication.sendDragEndEvent()

    document.removeEventListener(DOMEvents.MOUSEUP, handleDragEnd)
    document.removeEventListener(DOMEvents.MOUSEMOVE, handleMousemove)
    document.removeEventListener(DOMEvents.MOUSELEAVE, handleMouseLeaveEvent)

    document.removeEventListener(DOMEvents.TOUCHEND, handleDragEnd)
    document.removeEventListener(DOMEvents.TOUCHMOVE, handleTouchmove)
  }

  function handleDragging(event: MouseEvent | Touch) {
    // send drag event to parent
    const offsetX = event.clientX - baseMouseX
    const offsetY = event.clientY - baseMouseY
    meetingClient.parentPageCommunication.sendDragMoveEvent(offsetX, offsetY)
  }

  function handleMousemove(event: MouseEvent) {
    event.preventDefault()
    return handleDragging(event)
  }

  function handleTouchmove(event: TouchEvent) {
    event.preventDefault()
    return handleDragging(event.touches[0])
  }

  function handleMouseLeaveEvent() {
    // Cursor has moved out of the draggable div
    handleDragEnd()
  }

  function handleDragStart(event: MouseEvent | Touch) {
    // save initial position
    baseMouseX = event.clientX
    baseMouseY = event.clientY
    container.style.transition = "" // Remove

    meetingClient.parentPageCommunication.sendDragStartEvent(baseMouseX, baseMouseY)

    document.addEventListener(DOMEvents.MOUSEUP, handleDragEnd)
    document.addEventListener(DOMEvents.TOUCHEND, handleDragEnd)
    document.addEventListener(DOMEvents.MOUSEMOVE, handleMousemove)
    document.addEventListener(DOMEvents.TOUCHMOVE, handleTouchmove)

    document.addEventListener(DOMEvents.MOUSELEAVE, handleMouseLeaveEvent)
  }

  function handleTouchstart(event: TouchEvent) {
    event.preventDefault()
    return handleDragStart(event.touches[0])
  }

  function handleMousedown(event: MouseEvent) {
    // Prevent the default drag behavior.
    event.preventDefault()
    return handleDragStart(event)
  }

  // listen mouse and touch start event
  container.addEventListener(DOMEvents.MOUSEDOWN, handleMousedown)
  container.addEventListener(DOMEvents.TOUCHSTART, handleTouchstart)

  return () => {
    // release all the event listeners
    container.removeEventListener(DOMEvents.MOUSEDOWN, handleMousedown)
    container.removeEventListener(DOMEvents.TOUCHSTART, handleTouchstart)

    document.removeEventListener(DOMEvents.TOUCHEND, handleDragEnd)
    document.removeEventListener(DOMEvents.TOUCHMOVE, handleTouchmove)

    document.removeEventListener(DOMEvents.MOUSEUP, handleDragEnd)
    document.removeEventListener(DOMEvents.MOUSEMOVE, handleMousemove)
    document.removeEventListener(DOMEvents.MOUSELEAVE, handleMouseLeaveEvent)
  }
}
